import React, { Fragment } from 'react';
import { ReactComponent as DisplayIcon } from 'assets/icons/dp.svg';
import { ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';
import { ArrowDownIcon, AmountIcon, LogoutIcon, SettingsIcon } from 'cokitchen-icons';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownList } from '@cokitchen/cokitchen-components';

import useDashboardContext from 'contexts/dashboard.context';

const Profile = () => {
  const firstName = localStorage.getItem(STORAGE_KEYS.FIRST_NAME) ?? 'Marketing';
  const lastName = localStorage.getItem(STORAGE_KEYS.LAST_NAME) ?? 'Rep';
  const navigate = useNavigate();
  const { permissions } = useDashboardContext();

  const logout = () => {
    localStorage.clear();
    navigate(ROUTE_KEYS.LOGIN);
  };
  const disableDropDown = !permissions.canViewProfileDropDown;

  const list = [
    {
      name: 'pricing',
      icon: <AmountIcon className='w-4 h-4' />,
      link: ROUTE_KEYS.PRICING,
      iconColor: 'text-gray-4',
      disableDropDown
    },
    {
      name: 'manage base meals',
      icon: <AmountIcon className='w-4 h-4' />,
      link: ROUTE_KEYS.MANAGE_BASE_MEALS,
      iconColor: 'text-gray-4',
      disableDropDown
    },
    {
      name: 'settings',
      icon: <SettingsIcon className='w-4 h-4' />,
      link: ROUTE_KEYS.SETTINGS,
      iconColor: 'text-gray-4',
      disableDropDown
    },
    {
      name: 'logout',
      onclick: logout,
      icon: <LogoutIcon className='w-4 h-4' />,
      styles: 'text-red-4'
    }
  ];

  return (
    <Dropdown
      placement='bottom'
      content={
        <div className='rounded-[40px] border px-2 md:px-4 py-2 flex gap-1 items-center border-gray-15'>
          <DisplayIcon className='max-sm:hidden text-[#707275]' />
          <span className='max-lg:hidden text-gray-6'>
            {firstName} {lastName}
          </span>
          <span className='lg:hidden text-gray-6'>
            {firstName[0]}
            {lastName[0]}
          </span>
          <ArrowDownIcon className='text-gray-8' />
        </div>
      }>
      <DropdownList>
        {list
          .filter((l) => !l.disableDropDown)
          .map((item, i) => (
            <DropdownItem key={i} onClick={item.onclick} className={`${item?.styles} capitalize`}>
              {item.link ? (
                <Link to={item.link} className='flex items-center'>
                  <span className={`pr-4 ${item?.iconColor}`}>{item?.icon}</span>
                  {item.name}
                </Link>
              ) : (
                <Fragment>
                  <span className={`pr-4 ${item?.iconColor}`}>{item?.icon}</span>
                  {item.name}
                </Fragment>
              )}
            </DropdownItem>
          ))}
      </DropdownList>
    </Dropdown>
  );
};

export default Profile;
